import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { CheckException } from '@treasury/domain/arp';
import { CheckExceptionService } from '@treasury/domain/arp/check-exception.service';
import { TmContainer } from '@treasury/presentation';
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { HeaderBarService } from '../../../services/jhd-header-bar.service';
import '../partials/decisions/check-exceptions-decision-confirmation';
import '../partials/decisions/check-exceptions-decisions-review';

export const tagName = 'check-exceptions-decision-workflow';
@customElement(tagName)
export class CheckExceptionsDecisionWorkflow extends TmContainer {
    @InjectProperty()
    declare private readonly navService: NavigationService;

    @InjectProperty()
    declare private readonly checkExceptionService: CheckExceptionService;

    @InjectProperty()
    declare private headerService: HeaderBarService;

    @state()
    private step = 1;

    @state()
    private reviewSheetOpen = false;

    @property()
    private checkExceptions: CheckException[] = [];

    @state()
    private successfulDecision = false;

    public async firstUpdated() {
        this.loading = false;
        this.initHeader();
        await this.checkExceptionService.ready();
    }

    public render() {
        if (this.loading) {
            return html`${this.renderLoader()}`;
        }

        switch (this.step) {
            case 1:
                return html`
                    <check-exceptions-decisions-review
                        .checkExceptions=${this.checkExceptions}
                        @close=${this.endWorkflow}
                        @submit=${() => this.submitCheckExceptionDecisions()}
                    >
                    </check-exceptions-decisions-review>
                `;
            case 2:
                return html`<check-exceptions-decision-confirmation
                    .checkExceptions=${this.checkExceptions}
                    @close=${this.endWorkflow}
                    .successfulDecision=${this.successfulDecision}
                >
                </check-exceptions-decision-confirmation>`;
            default:
                return nothing;
        }
    }

    private initHeader() {
        this.headerService.configure({
            title: 'Review Decisions',
            backAction: this.endWorkflow.bind(this),
        });
    }

    private endWorkflow() {
        this.step = 1;
        this.dispatchEvent(new CustomEvent('endReviewWorkflow'));
    }

    private async submitCheckExceptionDecisions() {
        await this.tryFetch(
            async () => {
                this.headerService.configure({
                    title: 'Submitting Check Decisions...',
                });
                return this.checkExceptionService.submitCheckExceptions(this.checkExceptions);
            },
            async (res: boolean) => {
                this.initHeader();
                this.successfulDecision = res;
                this.step = 2;
            }
        );
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: block;
                    height: 100%;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CheckExceptionsDecisionWorkflow;
    }
}
